<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/tab-bar" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">标签栏</div>

        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-text v-show="activeTabBar === 0">1</yu-text>
  <yu-text v-show="activeTabBar === 1">2</yu-text>
  <yu-text v-show="activeTabBar === 2">3</yu-text>
  <yu-text v-show="activeTabBar === 3">4</yu-text>
  <yu-tab-bar :tabBar="tabBar" @switch="handleSwitch"/>
      `,
      code2: `
  import { YuText, YuTabBar } from 'yu.mobile';

  export default {
    name: 'lists',
    data() {
      return {
        activeTabBar: 0,
        tabBar: [
          { label: '用户', icon: 'icon-user', badge: '12' },
          { label: '首页', icon: 'icon-home', badge: 'new' },
          { label: '购物', icon: 'icon-shopping-cart-full', dot: true },
          { label: '设置', icon: 'icon-cog' },
        ],
      }
    },
    methods: {
      handleSwitch(index, item) {
        this.activeTabBar = index;
      },
    },
    components: {
      YuTabBar,
      YuText,
    },
  };
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'tabBar',
          description: '标签栏内容[{label,icon},...],icon可选',
          types: 'Array',
          default: '无',
        },
        {
          prop: 'hide',
          description: '隐藏标签栏',
          types: 'Boolean',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'switch',
          description: '点击事件，切换标签栏',
          callback: '( index: Number, item: Object )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tab-bar.vue